/**
 * Updates window.setTimeout to use promise
 * @param timeout Number of milliseconds to wait
 */
export function setTimeout(timeout: number): Promise<void> {
  return new Promise((resolve, reject) => {
    window.setTimeout(() => resolve(), timeout);
  });
}
